import React, { useEffect, useState } from "react";
import style from "./Toast.module.scss";


const Toast = (props) => {

    const [toastShow, setToastShow] = useState('')
    const [loading, setLoading] = useState({
        totalTime: 0,
        remainTime: 0,
        width: 0
    })

    const toggle = () => {
        let childData = {
            label: props.tag,
        }
        if (toastShow) {
            setToastShow(false);
            childData.value = false;
        } else {
            setToastShow(true);
            childData.value = false;
        }
        props.parentClose(childData)
    }

    useEffect(() => {
        if (loading.totalTime != 0) {
            let changeLoading = setInterval(() => {
                let tmp = loading
                if (tmp.remainTime > 0) {
                    tmp.width = tmp.width + (100 / (loading.totalTime / 10))
                    tmp.remainTime = tmp.remainTime - 10
                    setLoading({ ...tmp })
                } else {
                    tmp.width = 0
                    tmp.remainTime = 0
                    tmp.totalTime = 0
                    setLoading({ ...tmp })
                    toggle()
                }
            }, 10)
            //Clean up can be done like this
            return () => {
                clearInterval(changeLoading);
            }
        }
    }, [loading.width]);

    useEffect(() => {
        if (props.value) {
            setToastShow(true);
            let time = props.text.length * 70
            if (time < 2000) {
                time = 2000
            }
            if (time > 7000) {
                time = 7000
            }
            setLoading({ ...loading, remainTime: time, totalTime: time, width: 1 })
        } else {
            setToastShow(false);
            setLoading({ ...loading, remainTime: 0, totalTime: 0, width: 0 })
        }
    }, [props.value]);

    return (
        <div className={style.ToastFrame}>
            <div className={toastShow ? `${style.alert}  ${props.type ? style[props.type] : style.error}` : style.hideAlert} id="toast">
                <div className={style.maxWrapper}>
                    <p className={style.textWrapper}>
                        <span className={style.icon}></span>
                        {props.text}
                    </p>
                    {props.hasButton && <button
                        className={style.extrabtn}
                        onClick={() => props.buttonAction()}
                    >
                        {props.buttonText}
                    </button>}
                </div>
                <div className={style.closeWrapper}>
                    <span onClick={toggle} className={style.closebtn}>e</span>
                </div>
                <div
                    className={style.loading}
                    style={{ width: `${loading.width}%` }}
                ></div>
            </div>
        </div>
    );
}

export default Toast;
/*
   type =====> success/error/warning/primary
   tag ======> name of toast
   value=true =======> showToast
   value=false  =======> hideToast
   text='' ==========> Toast text(REQUIRED)
   parentClose =====> set showToast to false
   hasButton ======> true/false
   buttonText ====> string
   buttonAction ====> function

   !!!**** very important toast need to have a div as container with height: 0px; to get Coordinates where to appeare and zero manipulation ; ****!!!
*/